import { EventEmitter } from '@angular/core';
import { Component, Input, OnInit, Output, ViewChild} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModuleTypes } from '../module-types';



@Component({
  selector: 'eos-share-documents',
  templateUrl: './share-documents.component.html',
  styles: []
})
export class ShareDocumentsComponent implements OnInit {
  @Input() public candidateDocs = [];
  @Input() moduleType = ModuleTypes.Exit;
  moduleTypes = ModuleTypes;
  @ViewChild('attachControl', { static: true }) ngSelectComponent: NgSelectComponent;
  @Output() attachClick: EventEmitter<any> = new EventEmitter<any>();
  selectedCandiFiles = [];

  ngOnInit() { }

  attachCandidateFilesToMail() {
    this.attachClick.emit(this.selectedCandiFiles);
    this.ngSelectComponent.handleClearClick();
  }

  onSelectingDoc(event) {
    this.selectedCandiFiles = event;
  }
}
